export default __webpack_public_path__ + "static/media/monica_segura_fibromialgia_en_positivo.da0e474d.jpg";